import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { HttpService } from '../../../services/http/http.service';


@Component({
  selector: 'app-question-difficulty',
  templateUrl: './question-difficulty.component.html',
  styleUrls: ['./question-difficulty.component.scss']
})
export class QuestionDifficultyComponent implements OnInit {

  difficultyNamesArr = ['Easy', 'Medium', 'Hard', 'Very Hard'];
  pointsArr = ['1', '2', '3', '4'];
  difficultyName = new FormControl('', [Validators.required]);
  marks = new FormControl('', [Validators.required, Validators.pattern('^[0-9]*')]);
  time = new FormControl('', [Validators.required, Validators.pattern('^[0-9]*')]);

  constructor(
    public dialogRef: MatDialogRef<QuestionDifficultyComponent>, public snackBar: MatSnackBar,
    private spinnerService: Ng4LoadingSpinnerService,
    private httpService: HttpService
  ) { }

  ngOnInit() {
  }


  closeDialog(flag: boolean): void {
    this.dialogRef.close(flag);
  }

  getDifficultyNameErrorMessage() {
    return this.difficultyName.hasError('required') ? 'Difficulty Name is required' :
      '';
  }

  getMarksErrorMessage() {
    return this.marks.hasError('required') ? 'Marks is required' :
      this.marks.hasError('pattern') ? 'Marks can only be numerical' :
        '';
  }

  getTimeErrorMessage() {
    return this.time.hasError('required') ? 'Time is required' :
      this.time.hasError('pattern') ? 'Time can only be numerical' :
        '';
  }

  addQuestionDifficulty() {
    var data = {
      difficultyName: this.difficultyName.value,
      marks: this.marks.value,
      time: this.time.value
    }
    if (data.marks > 0 && data.time > 0) {
      console.log("Test time Data", data);
    this.spinnerService.show();
    var contentBody = { url: "/questiondifficulties", body: data }
    this.httpService.httpPost(contentBody, true).subscribe(response => {
      console.log("success ", response);
      this.openSnackBar(response["message"]);
      this.spinnerService.hide();
      this.closeDialog(true);
    }, error => {
      console.log("error ", error);
      this.spinnerService.hide();
      this.openSnackBar(error.error.message);
    })
  }
  else {
    this.openSnackBar("Please provide valid data")
  }
  }
  openSnackBar(message: string) {
    this.snackBar.open(message, null, {
      duration: 2000,
    });
  }
}
